import type { RequiredDeep } from 'type-fest';
import type { LoggerContext } from './LoggerContext.type';

import { getCurrentCompanyId, getCurrentUserInfo, setCurrentUserInfo, setCurrentCompanyId } from 'Lib/Utils';
import { logger } from './logger';

/**
 * Initialise logger with context.
 *
 * We set the context whenever the {@link setCurrentUserInfo|user info} or the {@link setCurrentCompanyId|company} changes.
 * However, if user reloads or navigates directly to a page, we lose the context. By running this whenever the app
 * loads, we ensure that the context is always set.
 */
export const initialiseLogger = () => {
    const userInfo = getCurrentUserInfo();
    const companyId = getCurrentCompanyId();

    const context = {
        userId: userInfo?.sub,
        user: { id: userInfo?.sub, email: userInfo?.email, name: userInfo?.name }, // adding user information to context instead of user because I didn't find that information in datadog logs.
        companyId: companyId ?? undefined,
    };

    ({}) as RequiredDeep<typeof context> satisfies RequiredDeep<LoggerContext>; // eslint-disable-line no-type-assertion/no-type-assertion -- used for typechecking
    ({}) as RequiredDeep<LoggerContext> satisfies RequiredDeep<typeof context>; // eslint-disable-line no-type-assertion/no-type-assertion -- used for typechecking

    logger.setContext({
        ...logger.getContext(),
        ...(context satisfies LoggerContext),
    });
};
